module.exports = __webpack_public_path__ + "img/product_placeholder.ab0b300.svg";